/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createSQRT2 } from '../../factoriesAny.js';
export var SQRT2Dependencies = {
  BigNumberDependencies,
  createSQRT2
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesSQRT2.generated.js
// module id = null
// module chunks = 